/* eslint-disable */
// @ts-nocheck
import { errorBoundaryReport } from '@zyf2e/monitor-react'
import { init } from '@zyf2e/monitor-browser'
import { log } from '@zyf2e/monitor-browser'
import { MitoVue } from '@zyf2e/monitor-vue'
import { SDK_NAME } from '@zyf2e/monitor-browser'
import { SDK_VERSION } from '@zyf2e/monitor-browser'
import webLog from '../utils/phone'
import { reportRequet } from '../utils/manageMito'

let ua = '暂无飞书版本号'
if (typeof window !== 'undefined') {
  ua = window.navigator.userAgent.toString()
}
// return  MITO.init(oldObj)

export let CTTQ_MONITOR_DEBUG = false
export default class cttqMito {
  constructor() {
  }
  //初始化函数
  static init(options) {
    // 添加全局
    reportRequet(options)
    if (options.app) {
      options.app.use(MitoVue)
    }
    // 判断是否生产环境
    let isPRD = false

    // vue2 项目默认读取环境
    if(['PRD', 'production'].includes(process.env.NODE_ENV)){
      isPRD = true
    }

    // 如果有runEnv ，覆盖默认环境变量
    if(options.runEnv && options.runEnv.length > 0){
      isPRD = ['PRD', 'production'].includes(options.runEnv)
    }

    // 根据环境切换上报接口
    const QAS = "https://ainewqas.cttq.com/monitor/fe/inform"
    const PRD = "https://vuemonitor.cttq.com/monitor/fe/inform"
    let dsn = isPRD ? PRD : QAS;

    // 更新debug 模式状态
    CTTQ_MONITOR_DEBUG = options.debug ? true : false
    CTTQ_MONITOR_DEBUG = isPRD ? false : CTTQ_MONITOR_DEBUG
    if(CTTQ_MONITOR_DEBUG){
      console.log("--------------------------------------")
      console.log("----CTTQ-MONITOR---","  :  ", "开启DEBUG 模式")
      console.log("--------------------------------------")
      console.log("apikey", ":" , options.apikey )
      console.log("userInfo", ":" , options.userInfo )
      console.log("isPRD", ":" , isPRD )
      console.log("dsn", ":" , dsn )
      console.log("--------------------------------------")
    }

    let oldObj = {
      dsn: dsn,
      apikey: '',
      configReportXhr(xhr) {
        xhr.withCredentials = false
      },
      backTrackerId() {
        // 获取用户唯一id（可以是手机号）
        try {
          if (options.userInfo && Object.prototype.toString.call(options.userInfo) === '[object Object]' && Object.keys(options.userInfo).length > 0) {
            return (
              options.userInfo.personCode || options.userInfo.userDetail ? options.userInfo.userDetail.personCode : '' ||
                (options.userInfo.userInfo && options.userInfo.userInfo.person ? options.userInfo.userInfo.person.personCode : options.userInfo.userInfo.personCode)
            )
          }
        } catch (error) {
          console.log('参数可能异常，请检查传入的参数格式是否正确')
        }
      },
      beforeDataReport(e) {
        /**
         * 钩子函数:在每次发送事件前会调用
         *
         * @param {TransportDataType} event 上报的数据格式
         * @return {*}  {(Promise<TransportDataType | null | CANCEL> | TransportDataType | any | CANCEL | null)} 如果返回 null | undefined | boolean 时，将忽略本次上传
         * @memberof BaseOptionsHooksType
         */
        let personObj = {
          cityName: '',
          personName: '',
          deptHierarchyAll: '',
          positionName: '',
          personCode: '',
          device: '',
          system: '',
        }
        try {
          if (options.userInfo && Object.prototype.toString.call(options.userInfo) === '[object Object]' && Object.keys(options.userInfo).length > 0) {
            for (let key in personObj) {
              //如果用户定义的userInfo第一层数据中有personCode值，那么就在第一层取，如果没有在下层的userInfo中取
              if (options.userInfo.personCode) {
                e.authInfo[key] = (options.userInfo[key] ? options.userInfo[key] : e.authInfo[key]) || webLog[key]
              } else {
                e.authInfo[key] = options.userInfo.userDetail ? options.userInfo.userDetail[key] : '' ||
                  (options.userInfo.userInfo && options.userInfo.userInfo.person ? options.userInfo.userInfo.person[key] : options.userInfo.userInfo[key]) || webLog[key]
              }
            }
            if (options.customInfo) {
              for (let key in options.customInfo) {
                e.authInfo[key] = options.customInfo[key]
              }
            }
          }
        } catch (error) {
          console.log('参数可能异常，请检查传入的参数格式是否正确')
        }
        if (e.data.response) {
          if (e.data.response.data) {
            if (typeof e.data.response.data === 'string') {
              e.data.response.data = JSON.parse(e.data.response.data)
            }
          }
        }
        e.format = {
          type: e.data.type,
          url: e.data.url,
          customTag: e.data.customTag,
          personCode: e.authInfo.personCode || e.authInfo.trackerId,
          feishuVersion: ua,
          apikey: options.apikey || '',
          errorId: e.data ? e.data.errorId : '',
          trackerId: e.authInfo.trackerId,
          // message: e.data ? e.data.message : '',
        }
        return e
      },
      beforePushBreadcrumb(breadcrumb, hint) {
        /**
         * 钩子函数:在每次添加用户行为事件前都会调用
         *
         * @param {Breadcrumb} breadcrumb Breadcrumb的实例
         * @param {BreadcrumbPushData} hint 单次推入用户行为栈的数据
         * @return {*}  {(BreadcrumbPushData | CANCEL)} 如果返回 null | undefined | boolean 时，将忽略本次的push
         * @memberof BaseOptionsHooksType
         */
        // 过滤Breadcrumb里面的数据类型
        if (hint.type === 'Console') {
          return false
        }
        if (hint.type === 'Xhr') {
          return false
          if (hint.data.response) {
            if (hint.data.request.data) {
              if (typeof hint.data.request.data === 'string') {
                hint.data.request.data = JSON.parse(hint.data.request.data)
              }
            }
            if (hint.data.response.data) {
              if (typeof hint.data.response.data === 'string') {
                hint.data.response.data = JSON.parse(hint.data.response.data)
              }
            }
            if (hint.data.response.status === 200) {
              return false
            }
          }
        }
        return hint
      },
    }
    Object.assign(oldObj, options)
    oldObj.maxBreadcrumbs = 3
    oldObj.silentUnhandledrejection = true
    return init(oldObj)
  }
  //手动上报
  static log(options) {
    return log(options)
  }
  // 捕捉Vue框架抛出的错误(https://github.com/clouDr-f2e/mitojs/blob/master/docs/guide.md#vue26npm%E5%8C%85%E5%BD%A2%E5%BC%8F)
  // static MitoVue = MitoVue;
  // //sdk名称：string
  // static SDK_NAME = SDK_NAME;
  // //sdk版本：string
  // static SDK_VERSION = SDK_VERSION;
  // //react@next的ErrorBoundary的错误上报函数具体使用(https://github.com/clouDr-f2e/mitojs/blob/master/docs/guide.md#NPM%E5%8C%85%E5%BD%A2%E5%BC%8F)
  // static errorBoundaryReport = errorBoundaryReport;
}
